import {
    type GetAllNewsCategoriesResponseType,
    type GetAllNewsCategoriesRequestType
} from "./type";
import {
    request
} from "../request";

const GetAllNewsCategories = async (params: GetAllNewsCategoriesRequestType): Promise<GetAllNewsCategoriesResponseType> => {
    return await request<GetAllNewsCategoriesResponseType>("/news/getAllNewsCategories", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default GetAllNewsCategories;
